import { FILTERS_NAME_SET, FORM_NAME_SET, LAYOUT_TOGGLE, LIMIT_TOGGLE, PAGE_SET, SORT_BY_SET, SORT_ORDER_TOGGLE } from './actionTypes'

/**
 * Sets name filter.
 * @param {page} name
 * @returns {Object} Action Object
 */
export const setNameFilter = name => ({
  type: FILTERS_NAME_SET,
  payload: name,
})
/**
 * Sets name form value.
 * @param {page} name
 * @returns {Object} Action Object
 */
export const setNameForm = name => ({
  type: FORM_NAME_SET,
  payload: name,
})

/**
 * Sets page
 * @param {page} page
 * @returns {Object} Action Object
 */
export const setPage = page => ({
  type: PAGE_SET,
  payload: page,
})

/**
 * Sets sort by
 * @param {string} column
 * @returns {Object} Action Object
 */
export const setSortBy = column => ({
  type: SORT_BY_SET,
  payload: column,
})

/**
 * Toggles between grid & table layout.
 * @returns {Object} Action Object
 */
export const toggleLayout = () => ({
  type: LAYOUT_TOGGLE,
})

/**
 * Toggle through limit
 * @returns {Object} Action Object
 */
export const toggleLimit = () => ({
  type: LIMIT_TOGGLE,
})

/**
 * Toggles sort order
 * @returns {Object} Action Object
 */
export const toggleSortOrder = () => ({
  type: SORT_ORDER_TOGGLE,
})
